import { useEffect, useState } from "react";
import { ChipsList } from "./ChipsList";
import { validateEmail } from "./logics";
import { ChipsTextField } from "./styles";

export const ChipsInput = ({ onChange, placeholder, value, limit = 2, validationType, customValidation, ...props }) => {
  /**
   * @States
   */
  const [inputValue, setInputValue] = useState("");
  const [chips, setChips] = useState(value || []);
  const validationKeys = ["Enter", "Tab", validationType === "email" ? " " : null];

  /**
   * @Effects
   */
  useEffect(() => {
    if (value && Array.isArray(value)) {
      setChips(value);
    }
  }, [value]);

  /**
   * @Methods
   */
  const validate = (inputValue) => {
    if (customValidation) {
      return customValidation(inputValue);
    }
    if (validationType) {
      switch (validationType) {
        case "email":
          return validateEmail(inputValue);
        default:
          return true;
      }
    }
    return true;
  };
  const handleChipsChange = (newChips) => {
    if (value && typeof onChange === "function") {
      onChange(newChips);
    } else {
      setChips(newChips);
    }
  };
  const handleKeyDown = (event) => {
    const inputValue = event.target.value;

    if (!event.key) {
      event.key = "Enter";
    }

    if (validationKeys.includes(event.key)) {
      if (validate(inputValue)) {
        event.preventDefault();
        const newChips = [...chips];
        const duplicatedValues = newChips.indexOf(inputValue.trim());

        if (duplicatedValues !== -1) {
          setInputValue("");
          return;
        }
        if (!inputValue.replace(/\s/g, "").length) return;

        newChips.push(inputValue.trim());
        handleChipsChange(newChips);
        setInputValue("");
      }
    }
    if (chips.length && !inputValue.length && event.key === "Backspace") {
      const newChips = [...chips];
      newChips.pop();
      handleChipsChange(newChips);
    }
  };
  const handleDelete = (item) => () => {
    handleChipsChange([...chips].filter((chip) => chip !== item));
  };
  const handleInputChange = (event) => {
    setInputValue(event.target.value.trim());
  };

  return (
    <ChipsTextField
      size="small"
      variant="outlined"
      InputProps={{
        startAdornment: <ChipsList items={chips} onDelete={(item) => handleDelete(item)} limit={limit} />,
      }}
      onChange={(event) => {
        handleInputChange(event);
      }}
      placeholder={placeholder}
      onKeyDown={handleKeyDown}
      onBlur={handleKeyDown}
      value={inputValue}
      data-testid={props.id}
      {...props}
    />
  );
};
